export default __webpack_public_path__ + "static/media/10.fee2686c.png";